import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Headline1CenterProps extends ITextBoxProps {}

export const TextBoxMaxLine1Headline1Center = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Headline1,
  alignment = TextAligning.Center,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Headline1CenterProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
